module.exports = __webpack_public_path__ + "img/dsci0014.b3af2538.jpg";